import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cloudChiprApi,
  OffHoursSchedule2,
  ScheduleActionType2,
} from "../../../services/cloudchipr.api";
import {
  generateOffHoursUpdatingData,
  getOffHoursUpdatePayloadData,
} from "../../../components/pages/schedule/off-hours/utils/helpers/helpers";

export const offHoursPatchFixedCacheKey =
  "patchV2UsersMeOffHoursSchedulesByScheduleId-fixed-cache-key";

export const toggleOffHoursStatusThunk = createAsyncThunk(
  "offHours/toggleScheduleStatus",
  async (
    {
      schedule,
      status,
    }: {
      schedule: OffHoursSchedule2;
      status: ScheduleActionType2;
    },
    { dispatch },
  ) => {
    const {
      patchV2UsersMeOffHoursSchedulesByScheduleId,
      getV2UsersMeOffHoursSchedules,
    } = cloudChiprApi.endpoints;

    const payloadData = getOffHoursUpdatePayloadData(
      generateOffHoursUpdatingData({ ...schedule, status }),
    );

    await dispatch(
      patchV2UsersMeOffHoursSchedulesByScheduleId.initiate(payloadData, {
        fixedCacheKey: offHoursPatchFixedCacheKey,
      }),
    ).unwrap();
    await dispatch(
      getV2UsersMeOffHoursSchedules.initiate({}, { forceRefetch: true }),
    );
  },
);
